var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46875 0H1.53125C1.06543 0 0.6875 0.37793 0.6875 0.84375V8.15625C0.6875 8.62207 1.06543 9 1.53125 9H5.46875C5.93457 9 6.3125 8.62207 6.3125 8.15625V0.84375C6.3125 0.37793 5.93457 0 5.46875 0ZM3.5 8.4375C3.18887 8.4375 2.9375 8.18613 2.9375 7.875C2.9375 7.56387 3.18887 7.3125 3.5 7.3125C3.81113 7.3125 4.0625 7.56387 4.0625 7.875C4.0625 8.18613 3.81113 8.4375 3.5 8.4375ZM5.46875 6.53906C5.46875 6.65508 5.37383 6.75 5.25781 6.75H1.74219C1.62617 6.75 1.53125 6.65508 1.53125 6.53906V1.05469C1.53125 0.938672 1.62617 0.84375 1.74219 0.84375H5.25781C5.37383 0.84375 5.46875 0.938672 5.46875 1.05469V6.53906Z",
    fill: "black",
    fillOpacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e0406db455b2cb3529138f3b38ef5abd.svg";
export { ForwardRef as ReactComponent };